import React, { useEffect, useRef, useState } from "react";

const SvgMapModal = ({
  selectedPath,
  modalWidth = 600,
  modalContentComponent,
  handleCloseModal,
}) => {
  const ref = useRef(null);

  const show = !!selectedPath;

  const [className, setClassName] = useState("");

  useEffect(() => {
    if (!show) {
      setClassName("");
    } else {
      setClassName("info-text-active");
    }
  }, [show]);

  if (!show || !modalContentComponent(selectedPath)) return null;

  return (
    <div
      ref={ref}
      className={`info-text ${className}`}
      style={{
        position: "absolute",
        bottom: 20,
        left: "50%",
        transform: "translateX(-50%)",
        minWidth: modalWidth,
      }}
    >
      {handleCloseModal && <button onClick={handleCloseModal}>X</button>}

      <div className="modal-content-wrapper">
        {modalContentComponent && modalContentComponent(selectedPath)}
      </div>

      <div className="arrow-up"></div>
    </div>
  );
};

export default SvgMapModal;
